<template>
  <v-data-table
    :caption="this.user.name"
    disable-filtering
    :headers="headers"
    :items="items"
    :items-per-page="3"
    :mobile-breakpoint="350"
    class="mt-6 pt-6 mx-n2"
    locale="sv-SE"
    :footer-props="{
      itemsPerPageOptions: [3, 9],
      itemsPerPageAllText: 'Alla',
      itemsPerPageText: 'Per sida:',
    }"
  >
    <template v-slot:item.rating="{ item }">
      <div class="rating">{{ item.rating }}</div>
    </template>
    <template v-slot:item.average="{ item }">
      <div class="average">{{ item.average }}</div>
    </template>
    <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
      {{ pageStart }} - {{ pageStop }} av {{ itemsLength }}
    </template>
  </v-data-table>
</template>
<script>

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      headers: [
        {text: 'Namn', value: 'name'},
        {text: 'Betyg', value: 'rating'},
        {text: 'Snitt', value: 'average'}
      ],
    }
  },
  computed: {
    items () {
      let beers = []
      this.user.data.forEach(beer => {
        beers.push({name: beer.name, rating: beer.rating, average: beer.average})
      });
      return beers
    },
  }
}
</script>
<style lang="scss">
  .v-data-table {
    .text-start:last-child {
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .text-start:first-child {
      width: 100%;
    }
    .average, .rating {
      width: 50px;
    }
    .v-data-footer {
     justify-content: space-around;
    }
    .v-data-footer__select,
    .v-data-footer__pagination,
    .v-data-footer__select .v-select {
      margin: 8px;
    }
  }
</style>
